module.exports = __webpack_public_path__ + "img/react.764f65a2.png";